<section class="min-h-screen">
  <!-- Header -->
  <div class="mb-6">
    <h1 class="text-2xl font-bold tracking-tight text-primary-800 dark:text-primary-400">Categories</h1>
    <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">Manage product categories and their status</p>
  </div>

  <!-- Actions Row -->
  <div class="flex flex-wrap items-center justify-between gap-4 mb-5">
    <div class="flex-1 min-w-[260px] max-w-xs">
      <form [formGroup]="searchQuery">
        <input type="text" formControlName="name" placeholder="Filter categories..."
          class="w-full h-10 px-3 text-xs bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-800/20 focus:border-primary-800 transition-colors" />
      </form>
    </div>
    <div class="flex items-center gap-2">
      <button (click)="getCategories()"
        class="px-3 py-1.5 rounded-lg text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:text-slate-100 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 transition-colors flex items-center gap-1.5 text-xs font-semibold" title="Refresh">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>

        <span>Refresh</span>
      </button>
      <div class="flex items-center border border-slate-200 dark:border-slate-700 rounded-lg overflow-hidden">
        <button type="button" (click)="viewMode = 'table'" [class]="viewMode === 'table' ? 'p-1.5 bg-primary-800 text-white' : 'p-1.5 bg-white dark:bg-slate-800 text-slate-400 hover:text-slate-600 dark:text-slate-400'" title="Table view">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"/></svg>
        </button>
        <button type="button" (click)="viewMode = 'grid'" [class]="viewMode === 'grid' ? 'p-1.5 bg-primary-800 text-white' : 'p-1.5 bg-white dark:bg-slate-800 text-slate-400 hover:text-slate-600 dark:text-slate-400'" title="Grid view">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1V5zm10 0a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM4 15a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1v-4zm10 0a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"/></svg>
        </button>
      </div>
      @if (permissionService.canManage('categories')) {
      <button (click)="onCreateApplication()"
        class="flex items-center gap-2 px-3 py-1.5 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:text-slate-100 border border-slate-200 dark:border-slate-700 rounded-lg text-xs font-semibold transition-colors">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 4v16m8-8H4" />
        </svg>
        New Category
      </button>
      }
    </div>
  </div>

  <!-- Table / Grid Toggle -->
  @if (viewMode === 'table') {
  <div class="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl shadow-sm overflow-hidden">
   <div class="overflow-x-auto">
    <div class="min-w-[500px]">
    <div class="grid grid-cols-4 gap-2 bg-slate-50 dark:bg-slate-800/60 border-b border-slate-200 dark:border-slate-700 px-5 py-2.5">
      <div class="text-left"><p class="text-xs font-semibold text-slate-400">Register Date</p></div>
      <div class="text-left"><p class="text-xs font-semibold text-slate-400">Segment Name</p></div>
      <div class="text-left"><p class="text-xs font-semibold text-slate-400">Current Status</p></div>
      <div class="text-center"><p class="text-xs font-semibold text-slate-400">Actions</p></div>
    </div>
    <div class="min-h-[240px]">
      @if (isLoading) {
      <div class="flex items-center justify-center py-16"><app-progress-loader></app-progress-loader></div>
      } @else if (categories.length) {
      @for (category of categories; track category.id) {
      <app-category-table [category]="category" (loadCategoryEvent)="getCategories()"
        (updateCategoryEvent)="onUpdateCategory($event)" (showOverlayEvent)="onShowOverlay()"
        [isUpdateCategory]="isUpdateCategory"></app-category-table>
      }
      } @else {
      <div class="flex flex-col items-center justify-center py-16 text-center">
        <p class="text-sm font-bold text-slate-800 dark:text-slate-100">No categories yet</p>
        <p class="text-[11px] text-slate-500 dark:text-slate-400 mt-1">Create a category to start organising your products.</p>
      </div>
      }
    </div>
    </div>
   </div>
  </div>
  } @else {
  <!-- Grid View -->
  <div class="min-h-[240px]">
    @if (isLoading) {
    <div class="flex items-center justify-center py-16"><app-progress-loader></app-progress-loader></div>
    } @else if (categories.length) {
    <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
      @for (category of categories; track category.id) {
      <div class="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl p-5 hover:shadow-md transition-shadow">
        <div class="flex items-start justify-between mb-3">
          <p class="text-sm font-bold text-slate-900 dark:text-white truncate">{{ category.name }}</p>
          <span class="ml-2 shrink-0 px-2 py-0.5 rounded-md text-[10px] font-bold border uppercase tracking-widest"
            [class]="category.isActive ? 'bg-emerald-50 dark:bg-emerald-950/40 text-emerald-600 dark:text-emerald-400 border-emerald-100 dark:border-emerald-900' : 'bg-slate-50 dark:bg-slate-800/60 text-slate-400 border-slate-200 dark:border-slate-700'">
            {{ category.isActive ? 'Active' : 'Inactive' }}
          </span>
        </div>
        @if (category.description) {
        <p class="text-xs text-slate-500 dark:text-slate-400 line-clamp-2 mb-4">{{ category.description }}</p>
        }
        <div class="pt-3 border-t border-slate-100 dark:border-slate-700/50 flex items-center justify-between">
          <p class="text-[11px] text-slate-400">{{ category.createdAt | date:'dd MMM yyyy' }}</p>
          @if (permissionService.canManage('categories')) {
          <button (click)="onUpdateCategory(category)" class="p-1.5 rounded text-slate-400 hover:text-primary-800 dark:text-primary-400 hover:bg-slate-100 dark:hover:bg-slate-700 dark:bg-slate-900 transition-colors" title="Edit">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>
          </button>
          }
        </div>
      </div>
      }
    </div>
    } @else {
    <div class="flex flex-col items-center justify-center py-16 text-center">
      <p class="text-sm font-bold text-slate-800 dark:text-slate-100">No categories yet</p>
    </div>
    }
  </div>
  }

  <!-- Pagination -->
  @if (!isLoading && categories.length > 0) {
  <app-pagination [totalItems]="allCategories.meta.total || 0" [itemsPerPage]="categoryQueryParams.perPage || 10"
    [currentPage]="categoryQueryParams.page || 1" (pageChange)="onPageChange($event)"></app-pagination>
  }
</section>

<!-- Create Category Modal -->
@if (isCreateApplication) {
<div
  class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-md animate-in fade-in duration-300">
  <div class="absolute inset-0" (click)="onCloseApplication()"></div>
  <div
    class="relative w-full max-w-lg bg-white dark:bg-slate-800 rounded-2xl shadow-[0_32px_64px_-12px_rgba(0,0,0,0.14),0_0_0_1px_rgba(0,0,0,0.02)] overflow-hidden animate-in zoom-in-95 slide-in-from-bottom-4 duration-300">
    <!-- Top Brand Glow -->
    <div class="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary/40 via-primary to-primary/40"></div>

    <div class="flex items-center justify-between px-10 py-7 border-b border-slate-100 dark:border-slate-700/50 bg-slate-50 dark:bg-slate-800/60 backdrop-blur-md">
      <div>
        <div class="flex items-center gap-2 mb-1">
          <div class="w-2 h-2 rounded-full bg-primary-800 animate-pulse"></div>
          <h3 class="text-xs font-bold text-slate-900 dark:text-white uppercase tracking-widest leading-none">Category Registry</h3>
        </div>
        <p class="text-xxxs text-slate-500 dark:text-slate-400 font-bold uppercase tracking-wider">Define New Portfolio Segment</p>
      </div>
      <button (click)="onCloseApplication()"
        class="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-slate-900 dark:text-white hover:bg-white dark:bg-slate-800 hover:shadow-lg rounded-full transition-all duration-300 group">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
          class="group-hover:rotate-90 transition-transform duration-300">
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
    </div>
    <div class="p-10">
      <app-add-category (onCloseEvent)="onCloseApplication()" (loadCategoryEvent)="getCategories()"></app-add-category>
    </div>
  </div>
</div>
}

<!-- Update Category Modal -->
@if (isUpdateCategory) {
<div
  class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-md animate-in fade-in duration-300">
  <div class="absolute inset-0" (click)="onCloseUpdateCategory()"></div>
  <div
    class="relative w-full max-w-lg bg-white dark:bg-slate-800 rounded-2xl shadow-[0_32px_64px_-12px_rgba(0,0,0,0.14),0_0_0_1px_rgba(0,0,0,0.02)] overflow-hidden animate-in zoom-in-95 slide-in-from-bottom-4 duration-300">
    <!-- Top Brand Glow -->
    <div class="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary/40 via-primary to-primary/40"></div>

    <div class="flex items-center justify-between px-10 py-7 border-b border-slate-100 dark:border-slate-700/50 bg-slate-50 dark:bg-slate-800/60 backdrop-blur-md">
      <div>
        <div class="flex items-center gap-2 mb-1">
          <div class="w-2 h-2 rounded-full bg-primary-800"></div>
          <h3 class="text-xs font-bold text-slate-900 dark:text-white uppercase tracking-widest leading-none">Taxonomy Editor</h3>
        </div>
        <p class="text-xxxs text-slate-500 dark:text-slate-400 font-bold uppercase tracking-wider">Refine Segment Classification</p>
      </div>
      <button (click)="onCloseUpdateCategory()"
        class="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-slate-900 dark:text-white hover:bg-white dark:bg-slate-800 hover:shadow-lg rounded-full transition-all duration-300 group">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
          class="group-hover:rotate-90 transition-transform duration-300">
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
    </div>
    <div class="p-10">
      <app-add-category (onCloseEvent)="onCloseUpdateCategory()" (loadCategoryEvent)="getCategories()"
        [category]="category"></app-add-category>
    </div>
  </div>
</div>
}

<!-- Success Overlay -->
@if (showSuccess) {
<div class="fixed inset-0 z-50 flex items-center justify-center p-4" (click)="showSuccess = false">
  <div class="absolute inset-0 bg-slate-900/60"></div>
  <div class="relative" (click)="$event.stopPropagation()">
    <app-success></app-success>
  </div>
</div>
}